<template>
  <b-modal title="Lista de Templates" v-model="show" size="lg">
    <div class="modal-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE TEMPLATES :::::::::::::::::::::::::::: -->
      <b-table
        id="table-cert-temp"
        bordered
        hover
        small
        head-variant="light"
        :items="getFilterCertificados(filtro)"
        :fields="fields.certificadoTemplate"
      >
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="load(data.item)">
              <b-icon icon="file-earmark-arrow-down" variant="info"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <template #modal-footer>
      <b-form inline>
        <b-icon icon="search" variant="primary" scale="1.2" class="m-1" />
        <b-form-input
          id="cert-filter-tmp"
          type="search"
          size="sm"
          variant="warning"
          class="m-1 p-1"
          placeholder="Descrição"
          v-model="filtro"
        />
      </b-form>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useTemplateStore } from "@/stores/TemplateStore";
import TableFields from "@/tools/TableFields";
import Certificado from "@/models_reports/Certificado";

export default {
  name: "CertificadoTemplateModal",

  data() {
    return {
      show: false,
      fields: new TableFields(),
      template: new Certificado(),
      filtro: "",
    };
  },

  methods: {
    load(dados) {
      this.template.id = dados.id;
      this.template.proxima = dados.proxima;
      this.template.observacao = dados.observacao;
      this.templateStore.LISTAR_ITENS(dados.id).then(() => {
        this.template.itens = this.getCertificadoItens;
        this.$emit("loadTemplate", this.template);
        this.show = !this.show;
      });
    },

    call() {
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const templateStore = useTemplateStore();
    const { getCertificadoItens } = storeToRefs(templateStore);
    const { getFilterCertificados } = storeToRefs(templateStore);

    return {
      store,
      templateStore,
      getCertificadoItens,
      getFilterCertificados,
    };
  },
};
</script>

<style lang="scss" scoped>
#cert-filter-tmp {
  width: 22rem;
}
</style>
